// extracted by mini-css-extract-plugin
export default {"loginCenterContent":"Login_loginCenterContent__syaL6","loginFooter":"Login_loginFooter__EFV5+","version":"Login_version__pr2AC","logo":"Login_logo__W+opJ"};